import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { privateRequest } from "../../api/apiConfig/privateRequest";
import { viewCV } from "../../customHooks";
import { DeleteIcon, EditIcon } from "../../Icon";
import { createdCVAction } from "../../redux/actions/MasterActions";
import { CREATED_CV_DATA_START } from "../../redux/actionsTypes/Types";
import Loader from "../loader/Loader";
import SearchHeader from "../Reuseablecomponent/SearchHeader";
import Pagination from "../Reuseablecomponent/Pagination";
import { DATA_NOT_FOUND } from "../../constant";

const CreatedCV = () => {
  const dispatch = useDispatch();
  const { cv, createdAt, createdByName, pageCount, userIdName, isDataFetch } =
    useSelector((state) => state.master["createdCV"]);
  const [isdeletemodal, setIsdeletemodal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [data, setData] = useState([]);
  const [reload, setReload] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [pageSize, setPageSize] = useState(10);

  const getSearchValue = (value) => {
    setSearchValue(value);
  };

  const openModal = (e, value) => {
    setIsOpen(true);
    setData(value);
  };
  const openDeleteModal = (id) => {
    setIsdeletemodal(true);
    setDeleteId(id);
  };
  const closeDeleteModal = () => {
    setIsdeletemodal(false);
    setDeleteId(null);
  };
  const handleChange = (e) => {};

  const handleLoginSubmit = async (e) => {};

  const deletePropsConfig = {
    closeDeleteModal,
    // isdeletemodal,
    url: "cv",
    // deleteId:deleteId,
    setReload,
  };
  const crudConfig = {
    isOpen,
    data,
  };

  const getToken = () => {
    if (localStorage.getItem("authUser") !== null) {
      const user = JSON.parse(localStorage.getItem("authUser"));
      return user.data.token;
    }
  };
  const paginationProps = {
    setPageNo,
    pageSize,
    setPageSize,
    pageCount,
  };
  const handleView = async (id) => {
    viewCV("cv", id);
  };

  useEffect(() => {
    let payload = {};
    dispatch(
      createdCVAction(
        CREATED_CV_DATA_START,
        (payload = { searchValue, pageNo, pageSize })
      )
    );
  }, [searchValue, pageNo, pageSize, reload]);

  return (
    <div>
      <SearchHeader
        title="Created CV"
        openModal={openModal}
        getSearchValue={getSearchValue}
        setPageNo={setPageNo}
      />
      <div className="usertab">
        <div className="users">
          <table className="users__table">
            <thead className="users__table--thead">
              <tr style={{ cursor: "context-menu" }}>
                <th>Resource Name</th>
                <th>Created By</th>
                <th>Created Date</th>
                <th>View CV</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody className="users__table--tbody">
              {isDataFetch ? (
                <tr>
                  <td colSpan={9}>
                    <Loader />
                  </td>
                </tr>
              ) : cv.length === 0 ? (
                <tr>
                  <td colSpan={2} style={{ textAlign: "end", color: "red" }}>
                    {" "}
                    {DATA_NOT_FOUND}
                  </td>
                </tr>
              ) : (
                cv.map((data) => (
                  <tr>
                    <td>{data.username}</td>
                    <td>{data.createdBy}</td>
                    <td>
                      {new Date(moment(data.createdAt)).toLocaleDateString(
                        "en-US",
                        { year: "numeric", month: "long", day: "numeric" }
                      )}
                    </td>

                    <td
                      style={{ color: "blue" }}
                      onClick={() => handleView(data.id)}
                    >
                      {" "}
                      View
                    </td>

                    <td>
                      <Link to={`/create-cv`}>
                        <EditIcon />
                      </Link>
                      <DeleteIcon
                        openDeleteModal={openDeleteModal}
                        enable={true}
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Pagination {...paginationProps} />
    </div>
  );
};
export default CreatedCV;
